module.exports = __webpack_public_path__ + "static/media/jay_kolhe.cfda9e6e.png";